import { Link } from 'react-router-dom';

const articleCards = [
  {
    slug: '/artykul/kakobuy-spreadsheet-poradnik',
    category: 'Poradnik',
    readTime: '10 min',
    title: 'Kakobuy Spreadsheet – Kompletny Przewodnik 2026',
    excerpt: 'Wszystko, co musisz wiedzieć o Kakobuy Spreadsheet – od podstaw po zaawansowane porady zakupowe.',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20workspace%20scene%20with%20laptop%20displaying%20colorful%20spreadsheet%20interface%20and%20product%20categories%20grid%2C%20soft%20warm%20cream%20background%2C%20natural%20window%20light%20casting%20gentle%20shadows%2C%20modern%20clean%20desk%20setup%20with%20subtle%20stationery%20elements%2C%20editorial%20photography%20style%20with%20rich%20detail%20and%20harmonious%20composition%2C%20neutral%20warm%20tone%20palette%20throughout&width=600&height=400&seq=seo-card-01&orientation=landscape',
  },
  {
    slug: '/artykul/bezpieczenstwo-kakobuy',
    category: 'Bezpieczeństwo',
    readTime: '8 min',
    title: 'Czy Kakobuy Jest Bezpieczny?',
    excerpt: 'Analiza zabezpieczeń, systemu QC, ochrony danych i metod płatności na platformie Kakobuy.',
    image: 'https://readdy.ai/api/search-image?query=Professional%20cybersecurity%20concept%20with%20shield%20icon%20hologram%20over%20laptop%20on%20clean%20wooden%20desk%2C%20warm%20cream%20background%2C%20soft%20natural%20lighting%2C%20modern%20office%20setting%2C%20security%20lock%20symbols%20subtly%20integrated%2C%20editorial%20photography%20with%20sophisticated%20composition%2C%20trust%20and%20protection%20theme%2C%20warm%20neutral%20tones&width=600&height=400&seq=seo-card-02&orientation=landscape',
  },
  {
    slug: '/artykul/dostawa-polska',
    category: 'Dostawa',
    readTime: '7 min',
    title: 'Kakobuy Shipping do Polski – Przewodnik',
    excerpt: 'Metody dostawy, koszty, czas realizacji i porady jak zaoszczędzić na wysyłce do Polski.',
    image: 'https://readdy.ai/api/search-image?query=Modern%20logistics%20concept%20featuring%20cardboard%20packages%20with%20tracking%20labels%20on%20wooden%20surface%2C%20world%20map%20softly%20visible%20in%20background%2C%20warm%20cream%20tones%2C%20soft%20natural%20light%20from%20window%2C%20organized%20parcel%20arrangement%2C%20delivery%20and%20ecommerce%20theme%2C%20clean%20editorial%20composition&width=600&height=400&seq=seo-card-03&orientation=landscape',
  },
  {
    slug: '/artykul/jak-zaczac-kakobuy',
    category: 'Poradnik',
    readTime: '6 min',
    title: 'Kakobuy dla Początkujących – 5 Kroków',
    excerpt: 'Jak założyć konto, znaleźć produkty i złożyć pierwsze zamówienie – krok po kroku.',
    image: 'https://readdy.ai/api/search-image?query=Beginner%20friendly%20workspace%20setup%20with%20open%20notebook%20and%20pen%20next%20to%20laptop%20showing%20shopping%20interface%2C%20coffee%20cup%2C%20warm%20cream%20background%2C%20soft%20morning%20light%20streaming%20through%20window%2C%20organized%20clean%20desk%2C%20welcoming%20and%20approachable%20atmosphere%2C%20tutorial%20theme%2C%20warm%20neutral%20tones&width=600&height=400&seq=seo-card-04&orientation=landscape',
  },
  {
    slug: '/artykul/porownanie-agentow',
    category: 'Porównanie',
    readTime: '9 min',
    title: 'Kakobuy vs CNFans vs Superbuy',
    excerpt: 'Szczegółowe porównanie trzech najpopularniejszych agentów zakupowych z Chin.',
    image: 'https://readdy.ai/api/search-image?query=Professional%20comparison%20concept%20with%20three%20product%20boxes%20side%20by%20side%20on%20clean%20wooden%20surface%2C%20each%20representing%20different%20choice%20options%2C%20warm%20cream%20background%2C%20soft%20directional%20lighting%20creating%20subtle%20shadows%2C%20decision%20making%20theme%2C%20balanced%20composition&width=600&height=400&seq=seo-card-05&orientation=landscape',
  },
  {
    slug: '/artykul/najlepsze-produkty-2026',
    category: 'Ranking',
    readTime: '8 min',
    title: 'Najlepsze Produkty Kakobuy 2026 – Top Lista',
    excerpt: 'Ranking najpopularniejszych produktów – sneakersy, streetwear, akcesoria i perełki z Chin.',
    image: 'https://readdy.ai/api/search-image?query=Curated%20collection%20of%20stylish%20fashion%20and%20lifestyle%20products%20arranged%20on%20warm%20cream%20backdrop%2C%20sneakers%20hoodies%20accessories%20and%20bags%20in%20artistic%20flat%20lay%20composition%2C%20soft%20natural%20window%20light%2C%20premium%20product%20photography%2C%20trendsetting%20items%20display%2C%20modern%20consumer%20culture%20theme%2C%20warm%20neutral%20tones&width=600&height=400&seq=seo-card-06&orientation=landscape',
  },
  {
    slug: '/artykul/kakobuy-spreadsheet-poradnik',
    category: 'FAQ',
    readTime: '5 min',
    title: 'Kakobuy Spreadsheet – Najczęstsze Pytania',
    excerpt: 'Odpowiedzi na najczęściej zadawane pytania o Kakobuy Spreadsheet – FAQ dla kupujących.',
    image: 'https://readdy.ai/api/search-image?query=Modern%20help%20desk%20concept%20with%20question%20mark%20icon%20floating%20above%20open%20laptop%20on%20clean%20desk%2C%20warm%20cream%20background%2C%20soft%20natural%20lighting%2C%20organized%20workspace%20with%20notes%2C%20customer%20support%20and%20FAQ%20theme%2C%20editorial%20photography%2C%20warm%20neutral%20tones%2C%20inviting%20and%20helpful%20atmosphere&width=600&height=400&seq=seo-card-07&orientation=landscape',
  },
  {
    slug: '/artykul/bezpieczenstwo-kakobuy',
    category: 'Porady',
    readTime: '6 min',
    title: '5 Błędów przy Zakupach przez Kakobuy',
    excerpt: 'Unikaj najczęstszych błędów początkujących – sprawdź, co robią źle nowi użytkownicy Kakobuy.',
    image: 'https://readdy.ai/api/search-image?query=Warning%20sign%20concept%20with%20subtle%20red%20accent%20on%20otherwise%20neutral%20desk%20setup%2C%20laptop%20displaying%20checklist%20interface%2C%20warm%20cream%20background%2C%20soft%20natural%20lighting%2C%20mistake%20prevention%20theme%2C%20editorial%20photography%2C%20warm%20dominant%20tones%20with%20minimal%20accent%20colors%2C%20clean%20composition&width=600&height=400&seq=seo-card-08&orientation=landscape',
  },
  {
    slug: '/artykul/dostawa-polska',
    category: 'Porady',
    readTime: '5 min',
    title: 'Jak Zaoszczędzić na Wysyłce Kakobuy?',
    excerpt: 'Praktyczne wskazówki dotyczące obniżenia kosztów wysyłki – konsolidacja i wybór metody.',
    image: 'https://readdy.ai/api/search-image?query=Savings%20concept%20with%20coins%20and%20calculator%20on%20warm%20cream%20desk%20surface%2C%20laptop%20in%20soft%20focus%20background%2C%20natural%20window%20light%2C%20financial%20planning%20theme%2C%20minimalist%20photography%2C%20warm%20neutral%20tones%2C%20smart%20shopping%20and%20budgeting%20atmosphere&width=600&height=400&seq=seo-card-09&orientation=landscape',
  },
];

export default function SeoPreview() {
  return (
    <section id="poradnik" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            Poradniki i Artykuły Kakobuy Spreadsheet
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            Przeczytaj nasze <strong>artykuły SEO</strong> o Kakobuy Spreadsheet – od poradników dla początkujących po zaawansowane analizy bezpieczeństwa i porównania agentów zakupowych. Wszystko, czego potrzebujesz przed zakupami z Chin.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articleCards.map((article, idx) => (
            <Link
              key={`${article.slug}-${idx}`}
              to={article.slug}
              className="group bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden hover:border-primary-200 hover:shadow-sm transition-all duration-300 cursor-pointer flex flex-col"
            >
              {/* Card Image */}
              <div className="relative h-48 md:h-52 overflow-hidden bg-background-200">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  title={article.title}
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-md bg-background-50/90 backdrop-blur-sm text-foreground-800 text-xxs font-semibold whitespace-nowrap">
                    {article.category}
                  </span>
                </div>
              </div>

              {/* Card Content */}
              <div className="p-5 flex flex-col flex-1">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xxs text-foreground-500">{article.readTime} czytania</span>
                </div>
                <h3 className="font-heading text-base font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed flex-1 line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="mt-4 flex items-center gap-1.5 text-primary-500 text-xs font-semibold">
                  <span>Czytaj więcej</span>
                  <i className="ri-arrow-right-line text-xxs"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* View All Articles */}
        <div className="text-center mt-8">
          <Link
            to="/artykul/kakobuy-spreadsheet-poradnik"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            Zobacz wszystkie poradniki
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}